import React, { useEffect, useState } from "react";
import { Box, Flex, SimpleGrid, Text } from "@chakra-ui/react";
import ReactApexChart from "react-apexcharts";
import { useTranslation } from "react-i18next";
import useDataFetcher from "../../../../sheard components/hooks/useDataFetcher";
import Loading from "../../../../sheard components/Loading";
import BarChart from "./ChartTest";

const Chart = () => {
  const { i18n } = useTranslation();
  const [runCount, setRunCount] = useState(0);




  let lang = i18n.language;
  const { data, loading, error } = useDataFetcher(
    `Patient/GetChartDetails?direction=${lang}`
  );

  if (loading) {
    return (
      <Flex justifyContent={"center"} alignItems="center" marginTop={"300px"}>
        <Loading />
      </Flex>
    );
  }

  if (error) {
    return <div style={{ color: "red" }}>Error: {error.message}</div>;
  }

  let style = {
    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
  };

  return (
    <SimpleGrid
      columns={{ base: 1, md: 1, lg: 2, xl: 2 }}
      spacing={4}
      marginTop="50px"
      marginBottom="20px"
    >
      {data.map((data, index) => {
        const seriesData = data[1];
        const categories = data[2];
        const options = {
          chart: {
            type: "bar",
          },
          xaxis: {
            categories: categories,
            labels: {
              rotate: lang === "en" ? -45 : 45,
              style: {
                padding: "44px",
                color: "red !important",
              },
            },
          },
          toolbar: {
            tools: {
              show: false,
            },
          },
        };

        const chartData = [
          {
            name: data[0],
            data: seriesData,
          },
        ];

        return (
          <Box
            key={index}
            className="chart-container"
            style={style}
            marginBottom={"20px"}
            borderRadius="10px"
            padding={"10px"}
          >
            <Text
              textAlign={"center"}
              fontSize="xl"
              color="#46a0cd"
              fontWeight="bold"
              key={index}
            >
              {data[0]}
            </Text>



            <ReactApexChart
              options={options}
              series={chartData}
              type="bar"
              height={350}
            />
          </Box>
        );
      })} 
    </SimpleGrid>
  );
};

export default Chart;
